if (!customElements.get('product-inventory')) {
  class ProductInventory extends HTMLElement {
    constructor() {
      super();
      if (this.hidden) {
        this.initLazySection();
      } else {
        window.initLazyScript(this, this.initLazySection.bind(this));
      }
    }

    initLazySection() {
      this.inventoryNotice = this.querySelector('.js-inventory-notice');
      this.urgencyMessage = this.querySelector('.js-inventory-urgency');
      this.indicatorBar = this.querySelector('.js-inventory-indicator');
      this.variantInventory = this.getVariantInventory();

      const variantPicker = this.closest('.product-info').querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }

      this.updateInventory(
        parseInt(this.dataset.inventoryQuantity, 10),
        this.dataset.variantAvailable === 'true',
        this.dataset.inventoryPolicy
      );
    }

    getVariantInventory() {
      const dataEl = this.querySelector('[type="application/json"]');
      if (!dataEl) return [];
      try {
        return JSON.parse(dataEl.textContent);
      } catch (e) {
        console.warn('Inventory JSON error:', e);
        return [];
      }
    }

    handleVariantChange(evt) {
      if (evt.detail.variant) {
        const variant = this.variantInventory.find(v => v.id === evt.detail.variant.id);
        if (variant) {
          this.updateInventory(
            variant.inventory_quantity,
            variant.available,
            variant.inventory_policy
          );
        }
      } else {
        this.updateInventory(0, false);
        this.hidden = true;
      }
    }

    updateInventory(count, available, inventoryPolicy) {
      if (count === 0 && !available && this.hidden) return;

      const backorderText = this.dataset.textNoStockBackordered;
      const showCount = this.dataset.showCount === 'always' || this.dataset.showCount === 'low';
      const showUrgency = this.urgencyMessage !== null;
      const showNotice = this.dataset.showNotice === 'always'
        || (this.dataset.showNotice === 'low' && count <= parseInt(this.dataset.thresholdLow, 10));
      const allowBackordered = this.dataset.showNoStockBackordered !== 'false';

      // Bepaal inventory level
      let inventoryLevel;
      if (count <= 0) {
        if (inventoryPolicy === 'continue') {
          inventoryLevel = 'backordered';
        } else if (available) {
          inventoryLevel = 'in_stock';
        } else {
          inventoryLevel = 'none';
        }
      } else if (count <= parseInt(this.dataset.thresholdVeryLow, 10)) {
        inventoryLevel = 'very_low';
      } else if (count <= parseInt(this.dataset.thresholdLow, 10)) {
        inventoryLevel = 'low';
      } else {
        inventoryLevel = 'normal';
      }

      // Stel data-inventory-level in
      this.setAttribute('data-inventory-level', inventoryLevel);

      if (!showNotice || (count <= 0 && inventoryLevel === 'backordered' && !allowBackordered)) {
        this.hidden = true;
        return;
      }

      this.hidden = false;

      // Inventory notice: zelfde tekst als Liquid-output
      if (count == 1) {
        this.inventoryNotice.innerText = "Op voorraad " + `(${count} unit)`;
      } else if (count > 0){
        this.inventoryNotice.innerText = "Op voorraad " + `(${count} units)`;
      } else if (inventoryLevel === 'backordered') {
        this.inventoryNotice.innerText = "Nabesteld";
      } else {
        this.inventoryNotice.innerText = '';
      }

      // Urgency message
      if (showUrgency && this.urgencyMessage) {
        if (count > 0) {
          this.urgencyMessage.innerText = `(${count} units)`;
        } else if (inventoryLevel === 'backordered') {
          this.urgencyMessage.innerText = backorderText;
        } else {
          this.urgencyMessage.innerText = '';
        }
      }

      // Indicator bar
      if (this.indicatorBar) {
        this.indicatorBar.hidden = false;
        const scale = parseInt(this.dataset.scale, 10);
        const width = ((Math.min(count, scale) / scale) * 100).toFixed(1);
        this.indicatorBar.querySelector('span').style.width = `${width}%`;
      }
    }
  }

  customElements.define('product-inventory', ProductInventory);
}
